import { ACTIVE_SERVER_ID } from 'mk/settings';
import { homepageUrl } from 'mk2/apps/home/urls';
import { strollersUrl } from 'mk2/apps/strollers/urls';
import { Route } from 'mk2/containers/Application/Application';
import RedirectPage from 'mk2/pages/RedirectPage';

export const routes: Route[] = [ACTIVE_SERVER_ID !== 207 ?
{
    app: 'home',
    exact: true,
    path: homepageUrl,
    getPage: () => {
        return import('mk2/apps/home/containers/Home/HomePage' /* webpackChunkName: "home.Home" */);
    },
    modules: [ 'mk2/apps/home/containers/Home/HomePage' ],
} : {
    app: 'home',
    exact: true,
    path: homepageUrl,
    page: new RedirectPage({to: strollersUrl, permanent: true}),
}];
